import React, { useCallback, useMemo } from 'react';
import { FilterGroup } from '@lt/components';

import type { IFilter } from '../../../types';
import MultipleChoiceFilter from '../MultipleChoiceFilter';

const makeItems = (
  data,
  { customFilters, FILTER_NAMES, FILTER_DESCRIPTIONS = {} },
  currencyCode,
) =>
  customFilters
    .map((filterName) => {
      const filterData = data[filterName];

      if (!filterData) {
        return null;
      }

      const [item] = filterData;
      return {
        ...item,
        path: filterName,
        name: FILTER_NAMES[filterName],
        description: FILTER_DESCRIPTIONS[filterName],
        currencyCode,
      };
    })
    .filter(Boolean);

interface ICustomBooleanFilterGroup extends IFilter {
  Filter: any;
}

/**
 * Фильтр, составленный на фронте из кучи булевых фильтров
 * e.g: filter_aquapark, filter_thermal_fun, filter_pool
 */
export const CustomBooleanFilterGroup: React.FC<ICustomBooleanFilterGroup> = ({
  data = {},
  onChange = () => null,
  onClear = () => null,
  Filter = () => null,
  isMobile = false,
  className = '',
  currencyCode,
}) => {
  const items = useMemo(
    () => makeItems(data, Filter, currencyCode),
    [data, Filter, currencyCode],
  );

  const hasActiveFilters = items.some((item) => item.selected);

  const handleChange = useCallback(
    ({ path, id, selected }) => onChange({ path, diff: { id, selected } }),
    [onChange],
  );

  const handleClear = useCallback(
    () => items.forEach(({ path, selected }) => selected && onClear(path)),
    [items, onClear],
  );

  return (
    <FilterGroup
      className={className}
      label={Filter.filterLabel}
      onClear={handleClear}
      showClearBtn={hasActiveFilters}
      isMobile={isMobile}
    >
      <MultipleChoiceFilter
        items={items}
        onChange={handleChange}
        isMobile={isMobile}
      />
    </FilterGroup>
  );
};
